import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useApi from '../../hooks/api/base/useApi';
import { IBLModalLoader } from '@iblai/ibl-web-react-common';

export const ProviderAssociationStripeCallback = () => {
  const { launch_id } = useParams();
  const [searchParams] = useSearchParams();
  const stripeCheckoutId = searchParams.get('stripe_checkout_id');
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const api = useApi();
  const redirectionDelay = 10000;

  const handleStripeAssociationCheckout = async () => {
    const response = await api.get(
      `/api/provider-association/stripe/callback/${launch_id}`,
      {
        stripe_checkout_id: stripeCheckoutId,
      }
    );
    setLoaded(true);
    if (!response?.error) {
      setTimeout(() => {
        window.location.href = '/';
      }, redirectionDelay);
      //All went fine
    } else {
      //There was an error
      setError(true);
    }
  };

  useEffect(() => {
    handleStripeAssociationCheckout();
  }, []);

  const handleGoBack = () => {
    window.location.href = '/';
  };

  const Logo = () => (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 32,
        marginTop: 24,
        zIndex: 99999999,
        position: 'relative',
      }}
    >
      <img
        src="/images/logo.gif"
        alt="Logo"
        style={{ height: 60, objectFit: 'contain' }}
      />
    </div>
  );

  if (!loaded) {
    return (
      <>
        <style
          dangerouslySetInnerHTML={{
            __html: `
            .modal-loader-container {
                z-index: 99 !important;
            }
            `,
          }}
        />
        <div>
          <Logo />
          <IBLModalLoader
            loaderSize={50}
            displayText={'Association in progress...'}
          />
        </div>
      </>
    );
  }

  if (error) {
    return (
      <div>
        <Logo />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '70vh',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: 24 }}>
              <svg
                width="72"
                height="72"
                viewBox="0 0 72 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="36" cy="36" r="36" fill="#dc3545" />
                <path
                  d="M24 24L48 48M48 24L24 48"
                  stroke="white"
                  strokeWidth="5"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>
              Association failed
            </div>
            <div style={{ color: '#888', marginBottom: 24 }}>
              An error occurred while associating your account.
            </div>
            <button
              onClick={handleGoBack}
              style={{
                padding: '8px 24px',
                background: '#dc3545',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Logo />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '70vh',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: 24 }}>
            <svg
              width="72"
              height="72"
              viewBox="0 0 72 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="36" cy="36" r="36" fill="#28a745" />
              <path
                d="M22 37L32 47L50 29"
                stroke="white"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div style={{ fontSize: 24, fontWeight: 600, marginBottom: 8 }}>
            Association successful!
          </div>
          <div style={{ color: '#888', marginBottom: 16 }}>
            You'll be redirected to the app in a few seconds.
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <button
              onClick={handleGoBack}
              style={{
                padding: '8px 24px',
                background: '#1677ff',
                color: '#fff',
                border: 'none',
                borderRadius: 4,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Go to app
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
